export const colors = {
    blue: '#1e70a1',
    red: '#f24011',
    yellow: '#ff9e1b',
    green: '#14872c',
}

export const typography = {
    // eslint-disable-next-line @internations/curly-quotes
    fontFamilyDefault: '"Open Sans", sans-serif',
    fontFamilyBrand: 'Bryant, sans-serif',
}
